import React, { useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LoginResponse } from "../types";
import { ServerRoutes } from "../routes";

export default function LoginPage() {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username || !password) {
      setError("Please enter both email and password.");
      return;
    }

    try {
      const response = await axios.post<LoginResponse>(
        ServerRoutes.login,
        { username, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const data = response.data;

      setError("");
      await localStorage.setItem("token", data.tokens.accessToken);
      setTimeout(() => {
        navigate("/");
      }, 500);      
    } catch (err: any) {
      const message =
        err.response?.data?.message || err.message || "Login failed.";
      setError(message);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f3f4f6",
        padding: 16,
      }}
    >
      <Card style={{ maxWidth: 400, width: "100%", padding: 24 }}>
        <CardContent>
          <Typography variant="h5" component="h2" align="center" gutterBottom>
            Login
          </Typography>
          <form
            onSubmit={handleLogin}
            style={{ display: "flex", flexDirection: "column", gap: 16 }}
          >
            <TextField
              type="text"
              label="Email"
              variant="outlined"
              fullWidth
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              type="password"
              label="Password"
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            )}
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Sign In
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
